import AbstractSpecification from "../specification/AbstractSpecification.js";
import accountOperationFactory from "../keyFigure/accountOperations/accountOperationFactory.js";

/**
 * `AccountGroupSpecification` is a concrete implementation
 * of `AbstractSpecification` representing a server side
 * specification of a group of accounts.
 *
 * @param {string} spec.groupId - Identifier of the account group
 * @param {string} spec.groupLabel - Label of the account group
 * @param {AbstractAccountOperation} spec.accountOperation - Account operation of the account group : Closing balance,
 * opening balance, period change, etc. It can be specified on a report row or column.
 */
export default class AccountGroupSpecification extends AbstractSpecification {
	constructor(spec = {}) {
		super(spec);
		this._groupId = spec.groupId;
		this._groupLabel = spec.groupLabel;
		this._accountOperation = spec.accountOperation;
	}

	getGroupId() {
		return this._groupId;
	}

	getName() {
		return this._groupLabel || this._groupId;
	}

	isLeaf() {
		return true;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitAccountGroupSpecification(
			this,
			additionalInformation,
		);
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.groupId = this._groupId;
		schema.groupLabel = this._groupLabel;
		schema.accountOperation = this._accountOperation?.serialize();

		return schema;
	}

	static getType() {
		return "AccountGroupSpecification";
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);
		data.groupLabel ||= context.getAccountName?.(data.groupId);

		data.accountOperation &&= accountOperationFactory.materialize(
			data.accountOperation,
			context,
		);
	}
}
